// interface texts (shared by all bingo cards). Task texts come from the card config.
const strings = {
    nl: {
        free: 'Gratis vak',
        hint: 'Tik op een vakje om een foto toe te voegen.',
        card: 'Kaart',
        language: 'Taal',
        remove: 'Foto verwijderen',
        confirmRemove: 'Deze foto verwijderen?',
        photoError: 'Deze foto kon niet worden geladen. Probeer een andere foto.',
        progress: '{done} van {total} foto\'s',
        bingoTitle: 'BINGO!',
        bingoTextFull: 'Gefeliciteerd, je kaart is vol!',
        bingoTextLine: 'Gefeliciteerd, je hebt een volle rij!',
        close: 'Sluiten',
    },
    en: {
        free: 'Free square',
        hint: 'Tap a square to add a photo.',
        card: 'Card',
        language: 'Language',
        remove: 'Remove photo',
        confirmRemove: 'Remove this photo?',
        photoError: 'This photo could not be loaded. Please try another one.',
        progress: '{done} of {total} photos',
        bingoTitle: 'BINGO!',
        bingoTextFull: 'Congratulations, your card is complete!',
        bingoTextLine: 'Congratulations, you completed a line!',
        close: 'Close',
    },
};

/**
 * Translate an interface key, falling back to English and then to the key itself.
 * Placeholders like {done} are replaced with values from `params`.
 */
export function t(lang, key, params = {}) {
    const text = strings[lang]?.[key] ?? strings.en[key] ?? key;

    return text.replace(/\{(\w+)\}/g, (match, name) => params[name] ?? match);
}
